import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {Card, Col, Layout, Modal, Row} from 'antd';

import './HomeScreen.css';
import {withRouter} from 'react-router-dom';
import SAInputLabel from '../components/common/input/SAInputLabel';
import SAButton from "../components/common/button/SAButton";

const { Content } = Layout;

class ChangeCarScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCar: null,
      selectedVin: null,
    };
  }

  componentDidMount() {
    // this.props.dispatchFetchVehicle();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.validatedVin && !this.props.validatedVin) {
      this.setState({
        selectedCar: null,
        selectedVin: null,
      });
      this.props.setSelectedVIN(nextProps.validatedVin);
      this.props.closeChangeCarModal();
    }
  }

  onSelectedVin = e => {
    var result = e.target.value.replace(" ", "");
    this.setState({ selectedVin: result.toUpperCase(), selectedCar: null });
  };

  chunkArray = (myArray, chunk_size) => {
    let index = 0;
    const arrayLength = myArray.length;
    const tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
      const myChunk = myArray.slice(index, index + chunk_size);
      // Do something if you want with the group
      tempArray.push(myChunk);
    }

    return tempArray;
  };

  onSelectCarClosure = car => () => {
    this.setState({ selectedCar: car, selectedVin: null });
  };

  renderCarDescription = (car, formatMessage) => (
    <React.Fragment>
      <Row style={{ fontWeight: 'bold' }}>{car.brand}</Row>
      <Row>{car.model}</Row>
      <Row>{`${formatMessage({ id: 'summary.vin' })}: ${car.vin.substring(
        car.vin.length - 7
      )}`}</Row>
      {car.reliability === 'NON_TRUSTED' && (
        <Row>{formatMessage({ id: 'customer.home.changeCar.notLinked' })}</Row>
      )}
      {car.notSupported && (
        <Row>{formatMessage({ id: 'customer.home.changeCar.notSupported' })}</Row>
      )}
    </React.Fragment>
  );

  renderCar = (car, formatMessage) => (
    <Card
      key={car.vin}
      bodyStyle={{
        padding: 0,
        backgroundColor: car.notSupported ? 'grey' : 'white',
        cursor: car.notSupported ? 'not-allowed' : 'grab',
        color: car.notSupported ? 'white' : 'black',
      }}
      style={{
        marginBottom: '5px',
        paddingBottom: 0,
        borderWidth:
          this.state.selectedCar && this.state.selectedCar.vin === car.vin
            ? '4px solid'
            : null,
      }}
      className={ this.state.selectedCar && this.state.selectedCar.vin === car.vin ? 'branded-border-color' : null}
      bordered
      onClick={!car.notSupported && this.onSelectCarClosure(car)}
    >
      <Row type="flex" style={{ padding: 10 }} gutter={16}>
        <Col span={12}>
          {car.picture && <img style={{ width: '80%' }} src={car.picture} />}
        </Col>

        <Col span={12} style={{ margin: 'auto' }}>
          {this.renderCarDescription(car, formatMessage)}
        </Col>
      </Row>
    </Card>
  );

  renderChunk = (chunk, index, formatMessage) => (
    <Row key={index} gutter={16} style={{ marginTop: 7 }}>
      {chunk.map(car => this.renderCar(car, formatMessage))}
    </Row>
  );

  handleChoose = () => {
    if (this.state.selectedVin) {
      // this.props.setSelectedVIN(this.state.selectedVin);
      this.props.dispatchCheckVIN({
        vin: this.state.selectedVin,
        dealer: this.props.dealer,
      });
    } else {
      this.props.closeChangeCarModal();
      this.props.setSelectedVehicle(this.state.selectedCar);
    }
  };

  handleClose = () => {
    this.setState({ selectedCar: null, selectedVin: null });
    this.props.closeChangeCarModal();
  };

  render() {
    const {
      intl: { formatMessage },
      vehicles,
      changeCarModal,
      dealer,
      vehicleNotSupported,
    } = this.props;
    let filteredVehicles;
    const { selectedVin, selectedCar } = this.state;
    if (!vehicles) {
      return null;
    }
    if (dealer) {
      filteredVehicles = vehicles.map(v => {
        if (!dealer.supportedBrands.includes(v.brand)) {
          v.notSupported = true;
        }
        return v;
      });
    } else {
      filteredVehicles = vehicles;
    }
    const selectedVinValid = !!selectedVin && selectedVin.length === 17;
    const chuncked = this.chunkArray(filteredVehicles, 3);
    return (
      <Modal
        title={<h3>{formatMessage({ id: 'customer.home.changeCar.title' })}</h3>}
        visible={changeCarModal}
        onCancel={this.handleClose}
        footer={
          <Row type={"flex"} gutter={16}>
            <Col lg={12}>
              <SAButton
                type="secondary"
                key="cancel"
                onClick={this.handleClose}
              >
                {formatMessage({ id: 'action.cancel' })}
              </SAButton>
            </Col>
            <Col lg={12}>
              <SAButton
                type="primary"
                key="back"
                disabled={!(!!selectedCar || selectedVinValid)}
                onClick={this.handleChoose}
              >
                {formatMessage({ id: 'action.select' })}
              </SAButton>
            </Col>
          </Row>
        }
      >
        <Layout className="layout" style={{ backgroundColor: 'white' }}>
          <Content style={{ margin: '0 auto' }}>
            <Row>
              {chuncked.map((chunk, i) => this.renderChunk(chunk, i, formatMessage))}
            </Row>
            <Row
              type="flex"
              gutter={16}
              style={{
                borderTop: '3px solid rgb(212, 212, 212)',
                marginTop: 16,
                paddingTop: 16,
              }}
            >
              <h3>{formatMessage({ id: 'customer.home.changeCar.addVin' })}</h3>
              <SAInputLabel
                label={'customer.home.changeCar.yourVin'}
                value={selectedVin}
                onChange={this.onSelectedVin}
                maxLength={17}
                minLength={17}
                error={
                  vehicleNotSupported
                    ? { message: 'customer.home.changeCar.notSupported' }
                    : null
                }
              />
            </Row>
          </Content>
        </Layout>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchVehicle: () => dispatch({ type: 'FETCH.CUSTOMER_VEHICLE.REQUEST' }),
  dispatchCheckVIN: params =>
    dispatch({ type: 'FETCH.CUSTOMER_VEHICLE_CHECK_VIN.REQUEST', params }),
  setSelectedVehicle: selectedVehicle => {
    dispatch({type: 'SET_SELECTED_VEHICLE', selectedVehicle})
    dispatch({type: 'SAVE.GENERAL_INFORMATION', params: {plateNumber: selectedVehicle.licensePlate}})
  },
  setSelectedVIN: selectedVIN => dispatch({ type: 'SET_SELECTED_VIN', selectedVIN }),
  closeChangeCarModal: () =>
    dispatch({ type: 'CHANGE_CAR_MODAL', changeCarModal: false }),
});

const mapStateToProps = state => ({
  loading: state.vehicles.loading,
  changeCarModal: state.customerVehicle.changeCarModal,
  validatedVin: state.customerVehicle.validatedVin,
  vehicleNotSupported: state.customerVehicle.vehicleNotSupported,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(ChangeCarScreen))
);



// WEBPACK FOOTER //
// ./src/public/ChangeCarScreen.js